import { useContext, useEffect, useReducer } from "react";
import { cardDivStyle } from "../../styles/styles";
import { basicReducer } from "../../util/General";
import { AppContext } from "../../context/AppProvider";
import { collection, onSnapshot, query } from "firebase/firestore";

const RaceResultsPage = () => {
  const appState = useContext(AppContext);
  const [designMap, dispatchDesignAction] = useReducer(basicReducer, {});
  const [fanMap, dispatchFanAction] = useReducer(basicReducer, {});

  useEffect(() => {
    if (appState.firebase && appState.firebase.db) {
      const votesQuery = query(collection(appState.firebase.db, "race_votes"));
      //if (appState.live.userteam_unsub) appState.live.userteam_unsub();
      const unSub = onSnapshot(votesQuery, handleVotes);
    }
  }, []);

  const handleVotes = (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      let voteData = change.doc.data().votes;
      console.log(voteData);
      if (change.type === "added") {
        if ("beast_design" in voteData) {
          let currentVotes = designMap[voteData["beast_design"]] || 0;
          dispatchDesignAction({
            type: "update",
            key: voteData["beast_design"],
            value: currentVotes + 1,
          });
        }
        if ("fan_favorite" in voteData) {
          let currentVotes = fanMap[voteData["fan_favorite"]] || 0;
          dispatchFanAction({
            type: "update",
            key: voteData["fan_favorite"],
            value: currentVotes + 1,
          });
        }
      }
      if (change.type === "modified") {
      }
      if (change.type === "removed") {
      }
    });
  };

  let highestDesign = 0;
  let highestFan = 0;

  console.log(JSON.stringify(designMap));
  console.log(JSON.stringify(fanMap));

  Object.keys(designMap).forEach((teamId) => {
    if (designMap[teamId] > highestDesign) {
      highestDesign = designMap[teamId];
      console.log(teamId, designMap[teamId]);
    }
  });
  Object.keys(fanMap).forEach((teamId) => {
    if (fanMap[teamId] > highestFan) {
      highestFan = fanMap[teamId];
      console.log(teamId, fanMap[teamId]);
    }
  });

  return <div style={cardDivStyle}></div>;
};

export { RaceResultsPage };
